import { render, staticRenderFns } from "./MyWallets.vue?vue&type=template&id=b5f946a6&"
import script from "./MyWallets.vue?vue&type=script&lang=js&"
export * from "./MyWallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports